import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@civicplus/preamble-ui/lib/Utilities/ThemeHelper";
import Typography from "@civicplus/preamble-ui/lib/Typography";
import { RootState } from "../app/store";
import HtmlParser from "html-react-parser";
import Grid from "@civicplus/preamble-ui/lib/Grid";
import Button from "@civicplus/preamble-ui/lib/Button";
import { Collapse } from "@material-ui/core";
import { alpha } from "@mui/material";
const useStyles = makeStyles(theme => ({
  announcementWrapper: {
    display: "flex",
    flexDirection: "column",
  },
  announcementText: {
    //updated scrollbar styling to match event listing.
    "&::-webkit-scrollbar-track": {
      backgroundColor: theme.palette.grey[300],
      borderRadius: theme.shape.borderRadius,
    },
    "&::-webkit-scrollbar": {
      width: 10,
    },
    "&::-webkit-scrollbar-thumb": {
      minHeight: "20px",
      backgroundColor: theme.palette.grey[500],
      borderRadius: theme.shape.borderRadius,
      "&:vertical": {
        height: 20,
        width: 20,
      },
      "&:hover": {
        backgroundColor: theme.palette.grey[600],
      },
    },
    //mainContainer looks at display size and not screen size. Works with embed.
    [`@container mainContainer (width < 900px)`]: {
      marginBottom: theme.spacing(1),
      overflow: "hidden",
      maxHeight: "80px",
    },
    [`@container mainContainer (width > 900px)`]: {
      maxHeight: "5rem",
      overflow: "auto",
      width: "100%",
    },
  },
  fadeText: {
    [`@container mainContainer (width < 900px)`]: {
      display: "inherit",
      position: "absolute",
      left: 0,
      right: 0,
      height: "5rem",
      transform: "translateY(-110%)",
      background: `linear-gradient(to top, ${alpha(
        theme.palette.grey[50],
        0.98
      )}, ${alpha(theme.palette.grey[50], 0)})`,
    },
    display: "none",
  },
  expandButton: {
    [`@container mainContainer (width > 900px)`]: {
      display: "none",
    },
    [`@container mainContainer (width < 900px)`]: {
      marginBottom: theme.spacing(0.5),
    },
  },
}));

const Announcement: React.FC = () => {
  const portalCustomization = useSelector(
    (state: RootState) => state.portalCustomization
  );
  const classes = useStyles();
  const [isExpanded, setIsExpanded] = useState(false);
  const [isShown, setIsShown] = useState(false);
  const [announcementHeight, setAnnouncementHeight] = useState<number>();
  const announcementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleWindowResize() {
      if (announcementRef.current) {
        const { scrollHeight, scrollWidth } = announcementRef.current;
        //Check for if button is expanded when transitioning back to scrollbar.
        scrollWidth > 900 && setIsExpanded(false);
        setIsShown(scrollHeight > 80);
        setAnnouncementHeight(scrollHeight < 80 ? scrollHeight : 80);
      }
    }
    handleWindowResize();
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  return (
    <Grid className={classes.announcementWrapper}>
      {portalCustomization?.publicPortalCustomText && (
        <Collapse in={isExpanded} collapsedSize={announcementHeight}>
          <Typography
            className={{
              [classes.announcementText]: !isExpanded,
            }}
            id="AnnouncementWrapper"
            innerRef={announcementRef}
          >
            {HtmlParser(portalCustomization.publicPortalCustomText)}
          </Typography>
          {isShown && !isExpanded ? (
            <div className={classes.fadeText} />
          ) : (
            <></>
          )}
        </Collapse>
      )}
      {isShown && (
        <Button
          onClick={() => setIsExpanded(!isExpanded)}
          size="small"
          color="primary"
          variant="text"
          className={classes.expandButton}
          aria-label={`${isExpanded ? "Read Less" : "Read More"} Announcement`}
          aria-controls="AnnouncementWrapper"
          aria-expanded={isExpanded}
        >
          {isExpanded ? "Read Less" : "Read More"}
        </Button>
      )}
    </Grid>
  );
};

export default Announcement;
